import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Logo } from "assets/svg";
import { clearInformationData } from "reducers/informationSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";

const RegisterComplete: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(clearInformationData());
  }, []);

  return (
    <main className="bg--blur box">
      <div className="w-full relative rounded-[20px] border-[8px] border-white bg-primary-light shadow-[0_0_15px_0_rgba(0,0,0,0.05)] flex flex-col items-center py-[40px] px-[14px] sm:max-w-[700px] sm:mx-auto sm:py-[60px] sm:px-[60px]">
        {/* Logo */}
        <Logo className="mx-auto w-[200px] h-[81px] mb-[20px] sm:w-[300px] sm:h-[121px] sm:mb-[30px]" />

        {/* Title */}
        <h2 className="text-[20px] font-bold text-[#20509F] text-center mb-[12px] sm:text-[28px] sm:mb-[18px]">
          登録申請完了
        </h2>
        <p className="text-[15px] text-center text-black mb-[28px] sm:text-[16px] sm:mb-[36px] leading-[1.7]">
          ご登録ありがとうございます。
          <br className="sm:hidden" />
          登録申請を受け付けました。
        </p>

        {/* 今後の流れ Section */}
        <section className="w-full mb-[26px] sm:mb-[38px]">
          <div className="flex items-center mb-[10px] sm:mb-[16px]">
            <span className="block w-[4px] h-[22px] bg-[#20509F] rounded-[2px] mr-[8px] sm:w-[6px] sm:h-[28px] sm:mr-[12px]"></span>
            <span className="text-[16px] font-bold text-[#20509F] sm:text-[18px]">
              今後の流れ
            </span>
          </div>
          <div className="border-t border-gray-200 mb-[10px] sm:mb-[18px]" />
          <ul className="pl-[18px] text-[14px] text-black leading-[1.8] sm:text-[15px]">
            <li className="list-disc mb-[2px]">
              ご提出いただいた情報と書類をもとに審査を行います。
            </li>
            <li className="list-disc mb-[2px]">
              審査には通常1〜2営業日かかります。
            </li>
            <li className="list-disc">
              審査完了後、登録メールアドレス宛にログインに必要な情報を記載したメールをお送りします。
            </li>
          </ul>
        </section>

        {/* ご注意 Section */}
        <section className="w-full mb-[32px] sm:mb-[44px]">
          <div className="flex items-center mb-[10px] sm:mb-[16px]">
            <span className="block w-[4px] h-[22px] bg-[#20509F] rounded-[2px] mr-[8px] sm:w-[6px] sm:h-[28px] sm:mr-[12px]"></span>
            <span className="text-[16px] font-bold text-[#20509F] sm:text-[18px]">
              ご注意
            </span>
          </div>
          <div className="border-t border-gray-200 mb-[10px] sm:mb-[18px]" />
          <ul className="pl-[18px] text-[14px] text-black leading-[1.8] sm:text-[15px]">
            <li className="list-disc mb-[2px]">
              審査に不備があった場合は、再提出のお願いを差し上げることがあります。
            </li>
            <li className="list-disc">
              迷惑メールフォルダなどもあわせてご確認ください。
            </li>
          </ul>
        </section>

        {/* Button */}
        <Link
          to={"/"}
          className="w-full text-center max-w-[350px] mx-auto bg-[#20509F] hover:bg-[#163d7b] text-white rounded-[8px] py-[15px] text-[16px] font-bold transition sm:text-[18px] sm:py-[18px]"
        >
          トップページへ戻る
        </Link>
      </div>
    </main>
  );
};

export default RegisterComplete;
